import React from 'react';
import { MailerLiteForm } from '../components/MailerLite';
import './Newsletter.css';

function Newsletter() {
  return (
    <div className="newsletter-page">
      <MailerLiteForm />
    </div>
  );
}

export default Newsletter;
